import { Component, OnInit, Input, Inject } from '@angular/core';
import { ReportBuilderService } from '../report-builder.service';
import { InspectionPhoto } from '../report-builder-models';
import { LoadingService } from '../../../../../shared/services/loading.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'add-photo-modal',
    templateUrl: './add-photo-modal.component.html',
    styleUrls: ['./add-photo-modal.component.scss']
})
export class AddPhotoModalComponent implements OnInit {

    RS_EQUIPMENT_PHOTOS_ONLY: number = 1;
    RS_ALL_INSPECTION_PHOTOS: number = 2;

    photoType: number = this.RS_ALL_INSPECTION_PHOTOS;
    inspectionID: number = 0;
    photos: InspectionPhoto[] = [];
    totalPhotos: number = 0;

    constructor(private _rbService: ReportBuilderService,
        private dialogRef: MatDialogRef<AddPhotoModalComponent>,
        private _loading: LoadingService,
        @Inject(MAT_DIALOG_DATA) public data: any) { }

    ngOnInit() {
        if (this.data.inspectionID != null) {
            this.inspectionID = this.data.inspectionID;

            if (this.data.photoType != null) {
                this.photoType = this.data.photoType;
            }

            this._loading.startLoading();
            if (this.photoType == this.RS_EQUIPMENT_PHOTOS_ONLY) {
                this._rbService.GetEquipmentPhotos(this.inspectionID).subscribe(res => {
                    if (res != null) {
                        this.photos = this.photos.concat(res);
                        //this.totalPhotos = this.photos.length;
                        this.recountImages();
                    }
                    this._loading.finishedLoading();
                });
            } else if (this.photoType == this.RS_ALL_INSPECTION_PHOTOS) {
                this._rbService.GetAllInspectionPhotos(this.inspectionID).subscribe(res => {
                    if (res != null) {
                        this.photos = this.photos.concat(res);
                        //this.totalPhotos = this.photos.length;
                        this.recountImages();
                    }
                    this._loading.finishedLoading();
                });
            } else {
                this._loading.finishedLoading();
            }

            
        }
    }

    recountImages() {
        // Ensure that image counts only include non-empty entries.
        for (var i = 0; i < this.photos.length; i++) {
            if ((this.photos[i].data != null) && (this.photos[i].data.length > 0)) {
                this.totalPhotos += 1;
            }
        }
    }

    addSelectedImage(e, id, photoType) {
        this.dialogRef.close({ data: { id, photoType } });
    }

    onCloseClick(): void {
        this.dialogRef.close();
    }
}
